import { Field } from './types';
import { useAtomValue } from 'jotai/index';
import { atom, useSetAtom } from 'jotai';
import { atomWithStorage } from 'utils/atomWithStorage';

export const allFields: Field[] = [
  'Matieres',
  'Domaines',
  'Competences',
  'Objectifs',
  'tags',
  'Activités',
  'attachments',
  'duration',
  'fichesDePrep',
  'materials',
  'status',
  'progItems',
];
export const fieldsDisplayedAtom = atomWithStorage<Field[]>(
  'cjDisplayedFields',
  allFields,
);

export const useFieldsToDisplay = () => useAtomValue(fieldsDisplayedAtom);
const toggleFieldToDisplayAtom = atom(null, (get, set, field: Field) => {
  const prev = get(fieldsDisplayedAtom);
  const updated = prev.includes(field)
    ? prev.filter(elt => elt !== field)
    : [...prev, field];
  return set(fieldsDisplayedAtom, updated);
});
export const useToggleFieldToDisplay = () =>
  useSetAtom(toggleFieldToDisplayAtom);

export const useSetFieldsToDisplay = () => useSetAtom(fieldsDisplayedAtom);
